import { formatCounty } from '@upstart/harmony/lib/formatter';
import uniq from 'lodash/uniq';
import UtilsService from 'services/UtilsService';
import useSWR from 'swr';

type CountyMap = {
  zipCode: string;
  state: string;
  county: string;
  city: string;
};

export const useCounties = (args: { dealerId: string; zipCode: string }) =>
  useSWR(args.dealerId && args.zipCode ? args : undefined, async () => {
    const countiesFetch = (await UtilsService.getCounties(args)) as CountyMap[];
    return uniq(countiesFetch.map(countyObj => formatCounty(countyObj.county)));
  });
